import cn from "classnames"

import { FriendlyLabelsStorage } from "components/Labels"
import { Img } from "ui-kit/components-branded/index"
import style from "modules/PsyCatalog/common/FriendlyBar.module.scss"
import { FRIENDLY_LABELS } from "components/Labels/constants"

const emojiBg = {
    className: "bg-lightgrey circle d-flex justify-content-center align-items-center",
    style: {
        width: "33px",
        height: "33px",
        fontSize: "26px",
    },
}

const label = "t-trans-uppercase font-size-0 mt-2 color-black-6 text-center"

interface FriendlyBarProps {
    friendly: boolean
    fem: boolean
    believer: boolean
    cancer: boolean
}

export function FriendlyBar({ friendly: friendly, fem, believer, cancer }: FriendlyBarProps) {
    const isFriendlyEnabled = FriendlyLabelsStorage.hasFriendlyLabel(FRIENDLY_LABELS.FRIENDLY)
    const isFemFriendlyEnabled = FriendlyLabelsStorage.hasFriendlyLabel(FRIENDLY_LABELS.FEM)
    const isBelieverEnabled = FriendlyLabelsStorage.hasFriendlyLabel(FRIENDLY_LABELS.BELIEVER)
    const isCancerEnabled = FriendlyLabelsStorage.hasFriendlyLabel(FRIENDLY_LABELS.CANCER)
    const showFriendly = friendly && isFriendlyEnabled
    const showFeminist = fem && isFemFriendlyEnabled
    const showCancer = cancer && isCancerEnabled
    const showBeliever =
        believer && isBelieverEnabled && !(showCancer && showFeminist && showFriendly)

    if (!(showFriendly || showFeminist || showCancer || showBeliever)) {
        return null
    }

    return (
        <div className={cn(style.parent, "pb-2")}>
            {showFriendly && (
                <div className={style.item}>
                    <div {...emojiBg}>
                        <Img style={{ width: "22px", height: "22px" }} src="purple_heart.png" />
                    </div>
                    <span className={label}>Френдли</span>
                </div>
            )}
            {showBeliever && (
                <div className={style.item}>
                    <div {...emojiBg}>
                        <Img style={{ width: "22px", height: "22px" }} src="church-emoji.png" />
                    </div>
                    <span className={label}>Работает с верующими</span>
                </div>
            )}
            {showFeminist && (
                <div className={style.item}>
                    <div {...emojiBg}>
                        <Img style={{ width: "22px", height: "22px" }} src="woman-emoji.png" />
                    </div>
                    <span className={label}>Фем-френдли</span>
                </div>
            )}
            {showCancer && (
                <div className={style.item} style={{ width: "39%" }}>
                    <div {...emojiBg}>
                        <Img style={{ width: "22px", height: "22px" }} src="cancer.png" />
                    </div>
                    <span className={label}>работает с онкопациентами</span>
                </div>
            )}
        </div>
    )
}
